// src/mixins/auth.mixin.js
import { loadRoutes } from '@/routes.js';
import { videoSyncManager } from "@/domain/GlobalFunctions/videoSyncManager";
import { useDashboardStore } from '@/stores/dashboards';

export default {
  data() {
    return {
      id: -1,
      refresh: true,
    };
  },
  methods: {
    async login(redirectToHomepage = true) {
      this.id = this.$session.get('logged_id');


      videoSyncManager.start(this, 30);

      const url = this.$session.get("api_url");
      const servername = this.$apiController.GetServerName(url);

      const cookieExpireTime = this.$cookie.getExpireTime() / 60;
      this.$cookie.setCookie("logged_id", this.id, cookieExpireTime);
      this.$cookie.setCookie("server_name", servername, cookieExpireTime);

      loadRoutes(this.$router);
      this.startTour();
      if (redirectToHomepage) {
        this.loadUser();
        this.$router.push('/').catch(() => {});
      }
      this.refresh = !this.refresh;
      this.stopInterval();
      this.startInterval();
    },
    logout() {
      const dashboardStore = useDashboardStore()
      this.$refs.headnav.stopRequests();
      this.$session.set('logged_id', 0);
      this.clearCookies();

      this.refresh = !this.refresh;
      this.$toast.clear();
      this.stopInterval();
      this.hideSideBar();
      dashboardStore.clear();
      videoSyncManager.stop();
    },
    clearCookies() {
      this.$cookie.eraseCookie("logged_id");
      this.$cookie.eraseCookie("server_name");
    },
    loadUser() {
      const user = this.$session.get('user');
      return this.dashboardService.listByUserId(this.id).then(dashboardList => {
        user.dashboards = dashboardList.filter(d => d.enable);
        this.$session.set("user", user);
      });
    },
    tryRestoreSession: async function () {
      const cookieSessionUserId = this.$cookie.getCookie("logged_id");
      const serverName = this.$cookie.getCookie("server_name");
      const token = this.$cookie.getCookie("jwt_token");
      const serverUrl = this.$apiController.GetServerURL(serverName);

      if (cookieSessionUserId != null && serverUrl != undefined && token) {
        this.$session.set("api_url", serverUrl);
        this.$apiController.ChangeApiURL(serverUrl);
        localStorage.setItem("jwt_token", token);

        try {
          const user = await this.userService.search(cookieSessionUserId);
          if (user.enable && user.id > 0) {
            this.$session.set('logged_id', user.id);
            this.$session.set('user', user);
            this.$session.set('privilege', user.privilege);
            await this.login(false);
          } else {
            this.clearCookies();
          }
        } catch (e) {
          console.error(e);
          this.clearCookies();
        }
      }
    },
  },
};
